import Vue from 'vue';
import VueRouter from 'vue-router';
import Applayout from '@/components/layout/app';
import Userlayout from '@/components/layout/user';
import NotFound from '@/views/NotFound.vue';
import { useAuthStore } from '@/stores/auth';
import { useSocketStore } from '@/stores/socket';
import { useCommonStore } from '@/stores/common';

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    component: () => import('./views'),
    meta: { auth: false }
  },
  {
    path: '/app',
    component: Applayout,
    redirect: '/app/',
    children: [
      {
        path: '',
        name: '메인',
        component: () => import('./views/app/index'),
        meta: { auth: true, title: '메인화면', subTitle: '메인화면' }
      },
      {
        path: 'test',
        name: '테스트페이지',
        component: () => import('./views/app/test'),
        meta: { auth: true, title: '테스트', subTItle: '테스트페이지' }
      },
      {
        // 메뉴 없음 · URL 직접접근(/app/proxyTest) · 로그인 불필요(auth:false)
        path: 'proxyTest',
        name: 'SSG프록시수집테스트',
        component: () => import('./views/app/proxyTest'),
        meta: { auth: false, title: 'SSG 프록시 수집 테스트', subTitle: 'SSG 프록시 수집 테스트' }
      },
      {
        path: 'gettingStarted',
        name: '개념잡기',
        component: () => import('./views/app/gettingStarted'),
        meta: { auth: true, title: '처음오신분 필독!! 개념잡기', subTitle: '처음오신분 필독!! 개념잡기' }
      },
      {
        path: 'gettingStarted_blank',
        name: '개념잡기',
        component: () => import('./views/app/gettingStarted'),
        meta: {
          auth: true,
          title: '처음오신분 필독!! 개념잡기',
          subTitle: '처음오신분 필독!! 개념잡기',
          openInNewTab: true
        }
      },
      {
        path: 'notice',
        name: '공지사항',
        component: () => import('./views/app/notice'),
        meta: { auth: true, title: '업데이트 및 공지사항', subTItle: '업데이트 및 공지사항' }
      },
      {
        path: 'productRecommend',
        name: '추천 소싱 키워드',
        component: () => import('./views/app/productRecommend'),
        meta: { auth: true, title: '추천 소싱 키워드', subTitle: '추천 소싱 키워드' }
      },
      {
        path: 'productRecommend_blank',
        name: '추천 소싱 키워드',
        component: () => import('./views/app/productRecommend'),
        meta: { auth: true, title: '추천 소싱 키워드', subTitle: '추천 소싱 키워드', openInNewTab: true }
      },
      {
        path: 'productSetting',
        name: '일반 소싱상품관리',
        component: () => import('./views/app/productSetting'),
        meta: { auth: true, title: '일반 소싱상품관리', subTitle: '일반 소싱상품관리' }
      },
      {
        path: 'productSetting_blank',
        name: '일반 소싱상품관리_blank',
        component: () => import('./views/app/productSetting'),
        meta: { auth: true, title: '일반 소싱상품관리', subTitle: '일반 소싱상품관리', openInNewTab: true }
      },
      {
        path: 'privateproductSetting',
        name: '비공개 소싱상품관리',
        component: () => import('./views/app/privateproductSetting'),
        meta: { auth: true, title: '일반 소싱상품관리', subTitle: '일반 소싱상품관리' }
      },
      {
        path: 'privateproductSetting_blank',
        name: '비공개 소싱상품관리_blank',
        component: () => import('./views/app/privateproductSetting'),
        meta: { auth: true, title: '비공개 소싱상품관리', subTitle: '비공개 소싱상품관리', openInNewTab: true }
      },
      {
        path: 'manualProductSetting',
        name: '전세계 사이트수동소싱',
        component: () => import('./views/app/manualProductSetting'),
        meta: { auth: true, title: '전세계 사이트수동소싱', subTitle: '전세계 사이트수동소싱' }
      },
      {
        path: 'manualProductSetting_blank',
        name: '전세계 사이트수동소싱_blank',
        component: () => import('./views/app/manualProductSetting'),
        meta: { auth: true, title: '전세계 사이트수동소싱', subTitle: '전세계 사이트수동소싱', openInNewTab: true }
      },
      {
        path: 'standbyProduct',
        name: '등록전상품관리',
        component: () => import('./views/app/standbyProduct'),
        meta: { auth: true, title: '등록전상품관리', subTitle: '등록전상품관리' }
      },
      {
        path: 'standbyProduct_blank',
        name: '등록전상품관리_blank',
        component: () => import('./views/app/standbyProduct'),
        meta: { auth: true, title: '등록전상품관리', subTitle: '등록전상품관리', openInNewTab: true }
      },
      {
        path: 'ProductManagement',
        name: '소싱상품수집',
        component: () => import('./views/app/productManagement'),
        meta: { auth: true, title: '소싱상품수집', subTitle: '소싱상품수집' }
      },
      {
        path: 'ProductManagement_blank',
        name: '소싱상품수집_blank',
        component: () => import('./views/app/productManagement'),
        meta: { auth: true, title: '소싱상품수집', subTitle: '소싱상품수집', openInNewTab: true }
      },
      {
        path: 'registeredProduct',
        name: '등록상품관리',
        component: () => import('./views/app/registeredProduct'),
        meta: { auth: true, title: '등록상품관리', subTitle: '등록상품관리' }
      },
      {
        path: 'registeredProduct_blank',
        name: '등록상품관리_blank',
        component: () => import('./views/app/registeredProduct'),
        meta: { auth: true, title: '등록상품관리', subTitle: '등록상품관리', openInNewTab: true }
      },
      {
        path: 'inventoryLinked',
        name: '재고관리',
        component: () => import('./views/app/inventoryLinked'),
        meta: { auth: true, title: '재고관리', subTitle: '' }
      },
      {
        path: 'inventoryLinked_blank',
        name: '재고관리_blank',
        component: () => import('./views/app/inventoryLinked'),
        meta: { auth: true, title: '재고관리', subTitle: '', openInNewTab: true }
      },
      {
        path: 'aiUpload',
        name: 'AI업로드',
        component: () => import('./views/app/aiUpload'),
        meta: { auth: true, title: 'AI업로드', subTitle: 'AI업로드' }
      },
      {
        path: 'aiUpload_blank',
        name: 'AI업로드_blank',
        component: () => import('./views/app/aiUpload'),
        meta: { auth: true, title: 'AI업로드', subTitle: 'AI업로드', openInNewTab: true }
      },
      {
        path: 'bulkWinform',
        name: '대량전용(윈폼)',
        component: () => import('./views/app/bulkWinform'),
        meta: { auth: true, title: '대량전용 프로그램(윈폼)', subTitle: '대량전용 프로그램(윈폼)' }
      },
      {
        path: 'bulkWinform_blank',
        name: '대량전용(윈폼)_blank',
        component: () => import('./views/app/bulkWinform'),
        meta: { auth: true, title: '대량전용 프로그램(윈폼)', subTitle: '대량전용 프로그램(윈폼)', openInNewTab: true }
      },
      {
        path: 'orderManagement',
        name: '주문관리',
        component: () => import('./views/app/orderManagement'),
        meta: { auth: true, title: '주문관리', subTitle: '' }
      },
      {
        path: 'orderManagement_blank',
        name: '주문관리_blank',
        component: () => import('./views/app/orderManagement'),
        meta: { auth: true, title: '주문관리', subTitle: '', openInNewTab: true }
      },
      {
        path: 'orderItemSearch',
        name: '주문상품조회',
        component: () => import('./views/app/orderManagement/orderItemSearch'),
        meta: { auth: true, title: '주문상품조회', subTitle: '' }
      },
      {
        path: 'orderItemSearch_blank',
        name: '주문상품조회_blank',
        component: () => import('./views/app/orderManagement/orderItemSearch'),
        meta: { auth: true, title: '주문상품조회', subTitle: '', openInNewTab: true }
      },
      {
        path: 'shopee',
        name: '쇼피',
        component: () => import('./views/app/shopee'),
        meta: { auth: true, title: 'ADS', subTitle: '' }
      },
      {
        path: 'shopee_blank',
        name: '쇼피',
        component: () => import('./views/app/shopee'),
        meta: { auth: true, title: 'ADS', subTitle: '', openInNewTab: true }
      },
      {
        path: 'statistics',
        name: '매출통계',
        component: () => import('./views/app/statistics'),
        meta: { auth: true, title: '매출통계', subTitle: '' }
      },
      {
        path: 'statistics_blank',
        name: '매출통계_blank',
        component: () => import('./views/app/statistics'),
        meta: { auth: true, title: '매출통계', subTitle: '', openInNewTab: true }
      },
      {
        path: 'salesReport',
        name: '매출리포트',
        component: () => import('./views/app/salesReport'),
        meta: { auth: true, title: '매출리포트', subTitle: '' }
      },
      {
        path: 'salesReport_blank',
        name: '매출리포트_blank',
        component: () => import('./views/app/salesReport'),
        meta: { auth: true, title: '매출리포트', subTitle: '', openInNewTab: true }
      },
      {
        path: 'productViewAnalysis',
        name: '상품조회수분석',
        component: () => import('./views/app/productViewAnalysis'),
        meta: { auth: true, title: '상품조회수분석', subTitle: '' }
      },
      {
        path: 'productViewAnalysis_blank',
        name: '상품조회수분석_blank',
        component: () => import('./views/app/productViewAnalysis'),
        meta: { auth: true, title: '상품조회수분석', subTitle: '', openInNewTab: true }
      },
      {
        path: 'vatReport',
        name: '부가세신고자료생성',
        component: () => import('./views/app/vatReport'),
        meta: { auth: true, title: '부가세신고자료생성', subTitle: '' }
      },
      {
        path: 'vatReport_blank',
        name: '부가세신고자료생성_blank',
        component: () => import('./views/app/vatReport'),
        meta: { auth: true, title: '부가세신고자료생성', subTitle: '', openInNewTab: true }
      },
      {
        path: 'productReport',
        name: '상품리포트',
        component: () => import('./views/app/productReport'),
        meta: { auth: true, title: '상품리포트', subTitle: '' }
      },
      {
        path: 'productReport_blank',
        name: '상품리포트_blank',
        component: () => import('./views/app/productReport'),
        meta: { auth: true, title: '상품리포트', subTitle: '', openInNewTab: true }
      },
      {
        path: 'stockLinkReport',
        name: '재고관리리포트',
        component: () => import('./views/app/stockLinkReport'),
        meta: { auth: true, title: '재고관리리포트', subTitle: '' }
      },
      {
        path: 'stockLinkReport_blank',
        name: '재고관리리포트_blank',
        component: () => import('./views/app/stockLinkReport'),
        meta: { auth: true, title: '재고관리리포트', subTitle: '', openInNewTab: true }
      },
      {
        path: 'vitapay',
        name: '선정산',
        component: () => import('./views/app/vitapay'),
        meta: { auth: true, title: '선정산(준비중)', subTitle: '선정산' }
      },
      {
        path: 'vitapay_blank',
        name: '선정산_blank',
        component: () => import('./views/app/vitapay'),
        meta: { auth: true, title: '선정산(준비중)', subTitle: '선정산', openInNewTab: true }
      },
      {
        path: 'addonService',
        name: '부가서비스',
        component: () => import('./views/app/addonService'),
        meta: { auth: true, title: '부가서비스', subTitle: '부가서비스 상품 구매' }
      },
      {
        path: 'preferences',
        name: '환경설정',
        component: () => import('./views/app/preferences'),
        meta: { auth: true, title: '환경설정', subTitle: '' }
      },
      {
        path: 'preferences_blank',
        name: '환경설정_blank',
        component: () => import('./views/app/preferences'),
        meta: { auth: true, title: '환경설정', subTitle: '', openInNewTab: true }
      },
      {
        path: 'subUserManagement',
        name: '직원계정관리',
        component: () => import('./views/app/subUserManagement'),
        meta: { auth: true, title: '직원계정관리', subTitle: '' }
      },
      {
        path: 'subUserManagement_blank',
        name: '직원계정관리_blank',
        component: () => import('./views/app/subUserManagement'),
        meta: { auth: true, title: '직원계정관리', subTitle: '', openInNewTab: true }
      },
       {
         path: 'productDashBoard',
         name: '상품 대시보드',
         component: () => import('./views/app/productDashBoard'),
         meta: { auth: true, title: '상품 대시보드', subTitle: '' }
       },
       {
         path: 'productDashBoard_blank',
         name: '상품 대시보드_blank',
         component: () => import('./views/app/productDashBoard'),
         meta: { auth: true, title: '상품 대시보드', subTitle: '', openInNewTab: true }
       },
      {
        path: 'marketAutoSetting',
        name: '자동 대량연동 설정',
        component: () => import('./views/app/marketAutoSetting'),
        meta: { auth: true, title: '자동 대량연동 설정', subTitle: '' }
      },
      {
        path: 'goodsCount',
        name: 'TotalProductCount',
        component: () => import('./views/app/marketAutoSetting/components/marketSetting/goodsCount'),
        meta: { auth: true, title: '자동 대량연동 설정', subTitle: '' }
      },
      {
        path: 'marketAutoSetting_blank',
        name: '자동 대량연동 설정_blank',
        component: () => import('./views/app/marketAutoSetting'),
        meta: { auth: true, title: '자동 대량연동 설정', subTitle: '', openInNewTab: true }
      },
      {
        path: 'bulkMarketUpload',
        name: '벌크마켓업로드',
        component: () => import('./views/app/bulkMarketUpload'),
        meta: { auth: true, title: '도신업로드', subTitle: '' }
      },
      {
        path: 'bulkMarketUpload_blank',
        name: '벌크마켓업로드_blank',
        component: () => import('./views/app/bulkMarketUpload'),
        meta: { auth: true, title: '도신업로드', subTitle: '', openInNewTab: true }
      },
      {
        path: 'luxProductSetting',
        name: '브랜드 소싱상품관리',
        component: () => import('./views/app/luxProductSetting'),
        meta: { auth: true, title: '브랜드 소싱상품관리', subTitle: '' }
      },
      {
        path: 'luxProductSetting_blank',
        name: '브랜드 소싱상품관리_blank',
        component: () => import('./views/app/luxProductSetting'),
        meta: { auth: true, title: '브랜드 소싱상품관리', subTitle: '', openInNewTab: true }
      },

      {
        path: 'marketProduct',
        name: '마켓 상품 가져오기',
        component: () => import('./views/app/marketProduct'),
        meta: { auth: true, title: '마켓 상품 가져오기', subTitle: '' }
      },
      {
        path: 'marketProduct_blank',
        name: '마켓 상품 가져오기_blank',
        component: () => import('./views/app/marketProduct'),
        meta: { auth: true, title: '마켓 상품 가져오기', subTitle: '', openInNewTab: true }
      },
      {
        path: 'socketManagement',
        name: '소켓 관리',
        component: () => import('./views/app/socketManagement'),
        meta: { auth: true, title: '소켓 관리', subTitle: '' }
      },
      // {
      //   path: 'workManagement',
      //   name: '작업 관리',
      //   component: () => import('./views/app/workManagement'),
      //   meta: { auth: true, title: '작업 관리', subTitle: '' }
      // }
    ]
  },
  {
    path: '/plan',
    component: Applayout,
    redirect: '/plan',
    children: [
      {
        path: '/',
        name: '결제관리',
        component: () => import('./views/plan'),
        meta: { auth: true, title: '결제관리', subTitle: '' }
      },
      {
        path: 'card',
        name: '구독카드',
        component: () => import('./views/planCard'),
        meta: { auth: true, title: '구독', subTitle: '' }
      },
      {
        path: 'complete',
        name: '결제완료',
        component: () => import('./views/plan'),
        meta: { auth: false, title: '결제완료', subTitle: '' }
      }
    ]
  },
  {
    path: '/app/template',
    component: Applayout,
    redirect: '/app/template',
    children: [
      {
        path: 'image',
        name: '상품템플릿',
        component: () => import('./views/app/template/image'),
        meta: { auth: true, title: '상품 템플릿', subTitle: '상품 템플릿' }
      },
      {
        path: 'image_blank',
        name: '상품템플릿',
        component: () => import('./views/app/template/image'),
        meta: { auth: true, title: '상품 템플릿', subTitle: '상품 템플릿', openInNewTab: true }
      },
      {
        path: 'upload',
        name: '마진 템플릿',
        component: () => import('./views/app/template/upload'),
        meta: { auth: true, title: '마진 템플릿', subTitle: '' }
      },
      {
        path: 'upload_blank',
        name: '마진 템플릿',
        component: () => import('./views/app/template/upload'),
        meta: { auth: true, title: '마진 템플릿', subTitle: '', openInNewTab: true }
      },
      {
        path: 'word',
        name: '단어설정 템플릿',
        component: () => import('./views/app/template/word'),
        meta: { auth: true, title: '단어설정 템플릿', subTitle: '' }
      },
      {
        path: 'word_blank',
        name: '단어설정 템플릿',
        component: () => import('./views/app/template/word'),
        meta: { auth: true, title: '단어설정 템플릿', subTitle: '', openInNewTab: true }
      },
      {
        path: 'AI',
        name: 'AI프롬프트 템플릿',
        component: () => import('./views/app/template/AI'),
        meta: { auth: true, title: 'AI프롬프트 템플릿', subTitle: '' }
      },
      {
        path: 'AI_blank',
        name: 'AI프롬프트 템플릿',
        component: () => import('./views/app/template/AI'),
        meta: { auth: true, title: 'AI프롬프트 템플릿', subTitle: '', openInNewTab: true }
      },
      {
        path: 'market',
        name: '마켓별 템플릿',
        component: () => import('./views/app/template/market'),
        meta: { auth: true, title: '마켓 템플릿', subTitle: '' }
      },
      {
        path: 'market_blank',
        name: '마켓별 템플릿',
        component: () => import('./views/app/template/market'),
        meta: { auth: true, title: '마켓 템플릿', subTitle: '', openInNewTab: true }
      },
      {
        path: 'CSTemplate',
        name: 'CS 템플릿',
        component: () => import('./views/app/template/CSTemplate'),
        meta: { auth: true, title: 'CS 템플릿', subTitle: '' }
      },
      {
        path: 'CSTemplate_blank',
        name: 'CS 템플릿',
        component: () => import('./views/app/template/CSTemplate'),
        meta: { auth: true, title: 'CS 템플릿', subTitle: '', openInNewTab: true }
      },
      {
        path: 'shopifyOAuthCallback',
        name: 'Shopify OAuth 콜백',
        component: () => import('./views/app/shopifyOAuthCallback'),
        meta: { auth: false, title: 'Shopify OAuth 인증', subTitle: '' }
      },
      {
        path: 'shopeeOAuthCallback',
        name: 'Shopee OAuth 콜백',
        component: () => import('./views/app/shopeeOAuthCallback'),
        meta: { auth: false, title: 'Shopee OAuth 인증', subTitle: '' }
      },
      {
        path: 'ebayOAuthCallback',
        name: 'Ebay OAuth 콜백',
        component: () => import('./views/app/ebayOAuthCallback'),
        meta: { auth: false, title: 'Ebay OAuth 인증', subTitle: '' }
      }
    ]
  },

  {
    path: '/user',
    component: Userlayout,
    redirect: '/user',
    children: [
      {
        path: '/',
        name: '로그인',
        component: () => import('./views/user/index'),
        meta: { auth: false, title: '로그인', subTitle: '' }
      },
      {
        path: 'certificate',
        name: '본인인증',
        component: () => import('./views/user/certificate'),
        meta: { auth: false, title: '본인인증', subTitle: '' }
      },
      {
        path: 'join',
        name: '회원가입',
        component: () => import('./views/user/join'),
        meta: { auth: false, title: '회원가입', subTitle: '' }
      },
      {
        path: 'findPass',
        name: '패스워드 찾기',
        component: () => import('./views/user/findPass'),
        meta: { auth: false, title: '패스워드 찾기', subTitle: '' }
      },
      {
        path: 'Modal/CheckPlusSuccess',
        name: '본인인증성공',
        component: () => import('./views/user/Modal/CheckPlusSuccess'),
        meta: { auth: false, title: '본인인증성공', subTitle: '' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: NotFound,
    meta: { auth: true }
  }
];

const router = new VueRouter({
  linkActiveClass: 'active',
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// 라우트 경로와 메뉴 키 매핑
const routeToMenuKeyMap = {
  'productRecommend': 'productRecommend',
  'productSetting': 'productSetting',
  'privateproductSetting': 'privateproductSetting',
  'manualProductSetting': 'manualProductSetting',
  'ProductManagement': 'ProductManagement',
  'luxProductSetting': 'luxProductSetting',
  'marketProduct': 'marketProduct',
  'standbyProduct': 'standbyProduct',
  'registeredProduct': 'registeredProduct',
  'inventoryLinked': 'inventoryLinked',
  'orderManagement': 'ordermanagement', // 경로는 orderManagement, 메뉴 키는 ordermanagement
  'ordermanagement': 'ordermanagement',
  'orderItemSearch': 'orderItemSearch',
  'statistics': 'statistics',
  'vatReport': 'vatReport',
  'productReport': 'productReport',
  'productViewAnalysis': 'productViewAnalysis',
  'salesReport': 'salesReport',
  'template/image': 'template/image',
  'template/upload': 'template/upload',
  'template/word': 'template/word',
  'template/market': 'template/market',
  'template/CSTemplate': 'template/CSTemplate',
  'vitapay': 'vitapay',
  'preferences': 'preferences',
  'subUserManagement': 'subUserManagement',
  'marketAutoSetting': 'marketAutoSetting',
  'bulkMarketUpload': 'bulkMarketUpload',
  'ProductDashBoard': 'ProductDashBoard',
  'productDashBoard': 'ProductDashBoard', // 대소문자 변형 대응
  'stockLinkReport': 'stockLinkReport',
};

router.beforeEach(async (to, from, next) => {

  const auth = useAuthStore();
  const socketStore = useSocketStore();
  const common = useCommonStore();

  // 로컬 스토리지에서 'openedTabs' 항목 삭제
  localStorage.removeItem('openedTabs');

  // 쇼피(Shopee) 인증 콜백 감지: 콘솔 Redirect URL Domain과 정확히 일치시키려 redirect를 루트(/)로 두었으므로,
  // 루트로 돌아온 code(+main_account_id/shop_id)를 콜백 처리 페이지로 자동 전달한다. (Shopify는 별도 경로라 무관)
  if (
    to.path !== '/app/shopeeOAuthCallback' &&
    to.query &&
    to.query.code &&
    (to.query.main_account_id || to.query.shop_id)
  ) {
    return next({ path: '/app/shopeeOAuthCallback', query: to.query });
  }

  // 이베이 인증 콜백 감지: 개발자센터의 "Your auth accepted URL"을 사이트 루트(예: https://smartcross.kr/)로
  // 등록하므로, 루트로 돌아온 code(+expires_in)를 콜백 처리 페이지로 자동 전달한다.
  if (
    to.path !== '/app/ebayOAuthCallback' &&
    to.query &&
    to.query.code &&
    to.query.expires_in &&
    !to.query.main_account_id &&
    !to.query.shop_id
  ) {
    return next({ path: '/app/ebayOAuthCallback', query: to.query });
  }

  // 특수 경로는 인증/권한 체크 없이 통과
  if (to.path === '/plan/complete') {
    return next();
  }
  // Shopify OAuth 콜백은 인증 없이 접근 가능
  if (to.path === '/app/shopifyOAuthCallback') {
    return next();
  }
  // Shopee OAuth 콜백은 인증 없이 접근 가능
  if (to.path === '/app/shopeeOAuthCallback') {
    return next();
  }
  // Ebay OAuth 콜백은 인증 없이 접근 가능
  if (to.path === '/app/ebayOAuthCallback') {
    return next();
  }

  // 인증 체크
  if (to.meta.auth === true && auth.accessToken === null) {
    next('/');
    return;
  }

  // 직원계정 권한 체크 (본계정은 모든 메뉴 접근 가능)
  // 메인화면(/app, /app/)은 권한 체크에서 제외
  if (to.meta.auth === true && to.path !== '/app' && to.path !== '/app/') {
    // 경로에서 메뉴 키 추출
    const pathParts = to.path.split('/').filter(p => p);
    const routePath = pathParts[pathParts.length - 1]?.replace('_blank', '');
    
    // 템플릿 경로는 전체 경로를 사용 (예: template/image, template/word 등)
    let menuKey;
    if (pathParts.length >= 2 && pathParts[pathParts.length - 2] === 'template') {
      // template/image, template/upload, template/word, template/market, template/CSTemplate
      const fullPath = `${pathParts[pathParts.length - 2]}/${pathParts[pathParts.length - 1]?.replace('_blank', '')}`;
      menuKey = routeToMenuKeyMap[fullPath] || fullPath;
    } else {
      menuKey = routeToMenuKeyMap[routePath] || routePath;
    }
    
    // 직원계정인 경우 권한 체크
    // isEmployeeAccount가 true이고, menuKey가 존재하며, 읽기 권한이 없는 경우 차단
    if (auth.isEmployeeAccount === true) {
      // menuPermissions를 최신 값으로 가져오기 (localStorage에서 직접 가져오거나 store에서 가져오기)
      const currentMenuPermissions = auth.menuPermissions || JSON.parse(localStorage.getItem('menuPermissions') || '{}');
      
      console.log('[Router] 권한 체크:', { 
        toPath: to.path,
        menuKey, 
        routePath, 
        isEmployeeAccount: auth.isEmployeeAccount, 
        menuPermissions: currentMenuPermissions,
        canRead: menuKey ? auth.canRead(menuKey) : 'menuKey 없음',
        routeToMenuKeyMap: routeToMenuKeyMap[routePath]
      });
      
      // menuKey가 없거나 빈 문자열이면 권한 체크를 건너뜀 (메인화면 등)
      if (menuKey && menuKey !== '' && !auth.canRead(menuKey)) {
        console.log('[Router] 권한 없음:', { menuKey, routePath, isEmployeeAccount: auth.isEmployeeAccount, menuPermissions: currentMenuPermissions });
        common.setToast('red', 'error', '이 메뉴에 대한 읽기 권한이 없습니다.');
        next('/app'); // 메인 페이지로 리다이렉트
        return;
      }
    }
  }

  // 새 창으로 열기 처리
  if (to.meta.openInNewTab) {
    const href = router.resolve(to).href.replace('_blank', '');
    let openedTabs = new Set(JSON.parse(localStorage.getItem('openedTabs') || '[]'));
    // Check if the URL has already been opened in a new tab
    if (!openedTabs.has(href)) {
      window.open(href, '_blank');
      openedTabs.add(href);  // Mark this URL as opened in a new tab
      localStorage.setItem('openedTabs', JSON.stringify(Array.from(openedTabs))); // 로컬스토리지에 업데이트
    }
    return next(false); // 현재 페이지 이동을 막음
  }

  // 실제로 페이지 이동이 일어나는 경우에만 타이틀 변경
  // socketIdx는 layout 컴포넌트의 watch에서 자동으로 업데이트되므로
  // 여기서는 기본 title만 설정 (socketIdx는 layout에서 추가됨)
  if (to.meta && to.meta.title) {
    // 사이트명 대신 메뉴명만 표시
    document.title = to.meta.title;
  } else {
    // title이 없는 경우
    const socketIdx = socketStore.getSocketIdx();
    if (socketIdx !== null && socketIdx !== undefined) {
      document.title = '메인화면'; // layout에서 socketIdx가 추가됨
    } else {
      document.title = ''; // 기본값은 비워 둠
    }
  }

  return next();
});

export default router;
